import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events, AlertController } from 'ionic-angular';
import { HttpClient } from '../../../../services/HttpClient';
import { CustomToast } from '../../../../util/CustomToast';

@Component({
  selector: 'page-offer',
  templateUrl: 'offer.html',
  providers : [HttpClient, CustomToast]
})
export class OfferPage {

  modalCtrl : ModalController;
	
  httpClient : HttpClient;

  offer = {
    id : -1,
    title : '',
    link : '',
    comments : '',
    active: '',
  };

  pdfs? = {
    id: -1,
    path: '',
    originialname: ''
  }

  filesToUpload?: any;
  tags = '';
  customToast : CustomToast;
  events : Events;
  alertCtrl : AlertController;

	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,customToast : CustomToast,modalCtrl : ModalController, events : Events, alertCtrl : AlertController) {
		this.modalCtrl = modalCtrl;
    this.httpClient = httpClient;
    this.customToast = customToast;
    this.events = events;
    this.alertCtrl = alertCtrl;
    this.filesToUpload;
    let id = navParams.get('id');
    this.httpCallOffer(id);
    this.httpCallPdf(id);
	}

  httpCallOffer(id){
    this.httpClient.get('/offers/'+id,(error,data)=>{
      if(!error){
        this.offer = data.json();
        this.httpCallPdf(id)
      }
    });
  }

  selectFile(fileInput: any){
    this.filesToUpload = <File> fileInput.target.files;
    console.log(this.filesToUpload)
  }


  httpCallPdf(id:number){
    this.httpClient.get('/pdfs/'+id,(error,data)=>{
      if(!error && data._body.length){
        this.pdfs = data.json();
        this.filesToUpload =this.pdfs.originialname
      
      }
    });
  }

  onClickSave(){
     this.httpClient.put('/offers',this.offer,(error,data)=>{
       if(!error){
        if(this.filesToUpload){
          this.httpPostOfferPdf()
        }else{
         this.customToast.showMessage('Oferta de trabajo actualizada',2000);
         this.navCtrl.pop();
         this.events.publish('offer:update');
       }
      }
     });
  }

  httpPostOfferPdf(){
    this.httpClient.delete('/pdfs/'+this.offer.id,(error,data)=>{
      if(!error){
        this.httpClient.upload('/pdfs',this.filesToUpload, this.tags, this.offer.id, (data: any)=>{
          this.customToast.showMessage('Oferta de trabajo actualizada',2000);
          this.navCtrl.pop();
          this.events.publish('offer:update');
        });
      }
    }); 
   
  }


  onClickDelete(){
    let alert = this.alertCtrl.create({
      title : '¿Estas seguro?',message : 'Vas a eliminar la información de esta oferta de trabajo',
      buttons:[{
        text : 'No',
        role : 'cancel'
        },
        {
        text : 'Si',
        role : 'confirm',
          handler : ()=>{
            this.httpCallDelete();
          }
        }
      ]
    });
    alert.present();
  }

  httpCallDelete(){
    this.httpClient.delete('/offers/'+this.offer.id,(error,data)=>{
      if(!error){
        this.httpClient.delete('/pdfs/'+this.offer.id,(error,data)=>{
        this.customToast.showMessage('Oferta de trabajo eliminada correctamente',2000);
        this.navCtrl.pop();
        this.events.publish('offer:delete');
      });
      }
    });
  }

  onClickDeleteFile(){
    let alert = this.alertCtrl.create({
      title : '¿Estas seguro?',message : 'Vas a eliminar el archivo adjunto de esta oferta de trabajo',
      buttons:[{
        text : 'No',
        role : 'cancel'
        },
        {
        text : 'Si',
        role : 'confirm',
          handler : ()=>{
            this.httpCallDeleteFile();
          }
        }
      ]
    });
    alert.present();
  }

  httpCallDeleteFile(){
    this.httpClient.delete('/pdfs/'+this.offer.id,(error,data)=>{
      if(!error){
        this.customToast.showMessage('Archivo eliminado correctamente',2000);
        this.navCtrl.pop();
        this.events.publish('offer:update');
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/offers/offer/offer.ts